import {useContext} from "react";

/** IMPORTS */
import { TYPE_THEME } from "../Constants/Const";
import { AuthContext } from "./AuthContext";

/** MUI */
import {Grid, Typography} from "@mui/material";

export function TitleComponent({title= null}){

    const {theme} = useContext(AuthContext);

    return !!title && (
        <Grid container style={{backgroundColor: theme.MUI === TYPE_THEME.light? "rgba(240, 240, 240, 0.8)":null}}
            direction="row"
            justifyContent="center"
            alignItems="center">
            <Typography variant="h6">{title}</Typography>
        </Grid>
    );
}